<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLFormAttributes } from 'svelte/elements';
  import { csrfToken } from "../lib/railsUtil.svelte";

  type Props = Omit<HTMLFormAttributes, "method"> & {
    method? : "get" | "post" | "patch" | "put" | "delete";
    form? : HTMLFormElement;
    children? : Snippet;
  };

  let {
    method: logicalMethod = "get",
    form = $bindable(),
    children,
    ...props
  } : Props = $props()
  let [method, railsMethod] = $derived(["get", "post"].includes(logicalMethod.toLowerCase()) ? [logicalMethod.toLowerCase() as "get" | "post", null] as const : ["post", logicalMethod] as const)
</script>
<form bind:this={form} {method} {...props}>
  {#if railsMethod}
    <input type="hidden" autocomplete="off" name="_method" value={railsMethod}>
  {/if}
  {@render children?.()}
  {#if method.toLowerCase() !== "get"}
    <input type="hidden" autocomplete="off" {...csrfToken()}>
  {/if}
</form>
